export interface AppAdministratorDashboardRootNotificationsFormUpdate {
  id: string;
  user_id: string;
  organization_id: string;
  user: {
    id: string;
    content: {
      name: string;
      surname: string;
    };
  };
  content: {
    roles: string;
    message: string;
  };
}

export class AppAdministratorDashboardRootNotificationsFormUpdate implements AppAdministratorDashboardRootNotificationsFormUpdate {
  id: string;
  user_id: string;
  organization_id: string;
  user: {
    id: string;
    content: {
      name: string;
      surname: string;
    };
  };
  content: {
    roles: string;
    message: string;
  };

  constructor() {
    this.id = "";
    this.user_id = "";
    this.organization_id = "";
    this.user = {
      id: "",
      content: {
        name: "",
        surname: "",
      },
    };
    this.content = {
      roles: "",
      message: "",
    };
  }
}